module.exports = __webpack_public_path__ + "img/nav3.aefb015c.svg";